const Connectivity = () => {
  return (
    <>
      <div className="about ms-md-4 ms-lg-5">Connectivity</div>
      <div className="border-bottom ms-md-4 ms-lg-5"></div>
      <ul className="text1 mx-auto ms-md-4 ms-lg-5">
        <li>
          <b>Through Air:</b> Mahayogi Gorakhnath Airport, Gorakhpur, Uttar
          Pradesh, 273002 is well connected with all major cities (Delhi,
          Mumbai, Hyderabad. Kolkata, Allahabad) and is 13 min. (6.4 km) away
          from MMMUT via Deoria Road / Gorakapur.
        </li>
        <li>
          <b>Through Rail:</b> Being an administrative headquarter of the
          Gorakhpur division, the city is well connected with all the major
          cities and Gorakhpur railway station is 6.3 km (2 min) away from MMMUT
          via Deoria Road/Gorakhpur.
        </li>
        <li>
          <b>Through Road:</b> Gorakhpur city, via national highway 28, 29, 233B
          is connected to all parts of the country by good roads and Gorakhpur
          bus station is 14 min (6.5 km) away from MMMUT via Derioa
          Road/Gorakhpur.
        </li>
      </ul>
    </>
  );
};

export default Connectivity;
